/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { gaSet } from "../../../../services/googleAnalyticsService";

const LoginPageMeta = () => {
  const title = "Login | Legalbird";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta
        name="description"
        content="In unserer Servicewelt erhalten Sie unser Rundum-Sorglos-Paket. Einfach, schnell, günstig und immer professionell beraten. Jetzt einloggen!"
      />
      <meta name="keywords" content="Einfache Onlinescheidung, Login, Einloggen, Servicewelt, Kundenbereich" />
      <meta name="robots" content="index,follow" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta
        property="og:description"
        content="In unserer Servicewelt erhalten Sie unser Rundum-Sorglos-Paket. Einfach, schnell, günstig und immer professionell beraten. Jetzt einloggen!"
      />
    </Helmet>
  );
};

export default LoginPageMeta;
